import { useEffect } from "react";
import { View } from "react-native";
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useStyle from "src/hooks/useStyle";
import IconUpload from "src/icons/IconUpload";
import { color } from "src/styles";
import { paddingXXL, paddingXXXL } from "src/styles/spacing";
import { Text } from "src/swsh-native";

const DragAndDropDisplay = () => {
	const { theme } = useStyle();
	const isHoveringImageFile = useGatheringStore((store) => store.isHoveringImageFile);
	const isHoveringSV = useSharedValue(false);

	useEffect(() => {
		isHoveringSV.value = isHoveringImageFile;
	}, [isHoveringSV, isHoveringImageFile]);

	const animatedStyle = useAnimatedStyle(
		() => ({
			borderWidth: withTiming(isHoveringSV.value ? 5 : 2),
			borderColor: withTiming(
				isHoveringSV.value ? color.Confirmation[theme] : color.Border[theme],
			),
		}),
		[isHoveringSV, theme],
	);

	return (
		<>
			<View
				style={{
					flex: 1,
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<Animated.View
					style={[
						{
							alignItems: "center",
							borderRadius: 20,
							paddingHorizontal: 120,
							paddingVertical: paddingXXXL,
							marginTop: paddingXXL,
						},
						animatedStyle,
					]}
				>
					<IconUpload size={60} />
					<Text
						bold
						style={{
							marginTop: paddingXXL,
						}}
					>
						Drag & Drop Files Here
					</Text>
				</Animated.View>
			</View>
		</>
	);
};
export default DragAndDropDisplay;
